
import React from 'react';

interface ProcessStepProps {
  step: {
    icon: React.ReactNode;
    title: string;
    desc: string;
  };
  index: number;
}

const ProcessStep: React.FC<ProcessStepProps> = ({ step, index }) => {
  return (
    <div className="text-center">
      <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-purple-500 rounded-full flex items-center justify-center text-white mx-auto mb-3">
        {step.icon}
      </div>
      <h4 className="text-lg font-semibold text-gray-900 mb-2">{step.title}</h4>
      <p className="text-gray-600 text-sm">{step.desc}</p>
    </div>
  );
};

export default ProcessStep;
